import React, { Component } from 'react';
// hoc
import { withRouter } from 'react-router-dom';
import { injectStripe } from 'react-stripe-elements';
// components
import Form from '../../../components/Form/Form';
// import Icon from '../../../components/Icon/Icon';
// import { Collapse } from 'react-collapse';
import { toast } from 'react-toastify';
// import CreditCard from './CreditCard';
import BankStatement from './BankStatement';
import CardElement from './CardElement';
import Button from '../../../components/Button/Button';
import Preloader from '../../../components/Preloader/Preloader';
// styles
import styles from './CheckoutForm.mod.css';
import classnames from 'classnames/bind';
import { toastResponseErrors } from '../../../utils/response';

const cx = classnames.bind(styles);

const style = {
  base: {
    fontFamily: '"Hind Vadodara", "Open Sans", sans-serif',
    '::placeholder': {
      color: '#808080',
    },
  },
  invalid: {
    color: '#000',
  },
};

class CheckoutForm extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      isGettingToken: false,
      isHelpOpen: !(props.isModal || props.isTablet),
    };
  }

  async handleSubmit(event) {
    event.preventDefault();
    const { subscriptionPlan, getSubscription, stripe } = this.props;
    const {
      id,
      price: { currency, fractional },
    } = subscriptionPlan;

    this.setState({ isGettingToken: true });
    const token = await stripe
      .createToken({
        amount: fractional,
        currency: currency.id,
      })
      .then(({ token, error }) => {
        this.setState({ isGettingToken: false });
        if (error) {
          toast.error(error.message);
          this.card.focus();
        }
        return token;
      });

    if (token) {
      const cart = token.card.last4;
      getSubscription({ stripe_token: token.id, plan_id: id })
        .then(() => {
          toast.success(`The card **** **** **** ${cart} successfully added!`);
        })
        .catch(toastResponseErrors);
    }
  }

  handleReset = () => {
    this.card.clear();
    this.cvc.clear();
    this.expiry.clear();
  };

  handleHelp = () => {
    const { isHelpOpen } = this.state;
    this.setState({
      isHelpOpen: !isHelpOpen,
    });
  };

  renderButtons = () => {
    const { isLoading, isSubscribed } = this.props;
    const { isGettingToken } = this.state;
    return (
      <>
        <div className={cx('buttons-section')}>
          <Button
            disabled={isLoading || isGettingToken || isSubscribed}
            className={cx('save')}
            type="submit"
            primary
          >
            Save
          </Button>
          <Button
            disabled={isLoading || isGettingToken || isSubscribed}
            className={cx('reset')}
            type="reset"
            link
          >
            Discard changes
          </Button>
        </div>
      </>
    );
  };

  renderBankStatement = () => (
    <div className={cx('bank-statement-wrapper')}>
      <div className={cx('bank-statement')}>
        <h3>You will be kept anonymous</h3>
        <BankStatement />
      </div>
    </div>
  );

  render() {
    const { /*isHelpOpen,*/ isGettingToken } = this.state;
    const { isLoading, isModal, isTablet, isSubscribed } = this.props;

    const buttons = this.renderButtons();

    return (
      <Form
        className={cx('wrapper', {
          'modal-wrapper': isModal,
        })}
        onSubmit={this.handleSubmit}
        onReset={this.handleReset}
      >
        <Preloader isActive={isGettingToken || isLoading} />
        <section className={cx('card-section')}>
          <div className={cx('card-form')}>
            <div className={cx('form-wrapper')}>
              <h3>Info</h3>
              <div className={cx('form-control')}>
                <label className={cx('label')}>Card number*</label>
                <CardElement
                  isSubscribed={isSubscribed}
                  type="cart"
                  onReady={c => (this.card = c)}
                  className={cx('card')}
                  style={style}
                />
              </div>
              <div className={cx('form-control')}>
                <label className={cx('label')}>CVC*</label>
                <CardElement
                  isSubscribed={isSubscribed}
                  type="cvc"
                  onReady={c => (this.cvc = c)}
                  className={cx('cvc')}
                  style={style}
                />
              </div>
              <div className={cx('form-control')}>
                <label className={cx('label')}>Date*</label>
                <CardElement
                  isSubscribed={isSubscribed}
                  type="date"
                  onReady={c => (this.expiry = c)}
                  className={cx('date')}
                  style={style}
                />
              </div>
              {!isModal && isSubscribed && (
                <p className={cx('cart-added-message')}>
                  The card successfully added!
                </p>
              )}
              {!(isModal || isTablet) && <>{buttons}</>}
            </div>
          </div>

          {/*
          // Possible need in the future
          <div className={cx('card-hint')}>
            <h3
              className={cx(styles.helpTitle, {
                active: isHelpOpen,
              })}
              onClick={this.handleHelp}
            >
              Help<span>(where to find info)</span>
              <Icon
                type="chevron-up"
                className={cx('chevron', {
                  rotated: isHelpOpen,
                })}
              />
            </h3>
            <Collapse isOpened={isHelpOpen} className={styles.cardCollapse}>
              <CreditCard />
            </Collapse>
          </div>
          */}

          {(isModal || isTablet) && <>{buttons}</>}
        </section>
      </Form>
    );
  }
}

export default withRouter(injectStripe(CheckoutForm));



// WEBPACK FOOTER //
// ./src/containers/Billing/components/CheckoutForm.jsx